import Alert from "../utils/alert"
import AuthService from "./auth"
import AuthMonitor from "./authMonitor"
import { DEFAULT_FILTER_AND_CFG_CLIENT, DEFAULT_FILTER_AND_CFG_CUSTOM, DEFAULT_FILTER_AND_CFG_FILLER, DEFAULT_FILTER_AND_CFG_MARKETING, DEFAULT_TABLE_CFG_CLIENT, DEFAULT_TABLE_CFG_CUSTOM, DEFAULT_TABLE_CFG_FILLER, DEFAULT_TABLE_CFG_MARKETING, SETTINGS_PROFILE } from "../components/financialTables/configuration/constants"
import UserSettingsRepo from "../utils/repository/userSettingsRepo"
import CloneUtils from "../utils/cloneUtils"


class UserPreferences {

    static FILTER_CFG_PROP = "filterCfg"
    static TABLE_CFG_PROP = "tableConfig"

    static CURRENT_SETTINGS_VERSION_PROP = "settingsV"
    static CURRENT_SETTINGS_VERSION = "18"
    static PROFILE_PROP = 'profile'

    static DEFAULTS = {
        CUSTOM: {
            [UserPreferences.FILTER_CFG_PROP]: DEFAULT_FILTER_AND_CFG_CUSTOM,
            [UserPreferences.TABLE_CFG_PROP]: DEFAULT_TABLE_CFG_CUSTOM
        },
        FILLER: {
            [UserPreferences.FILTER_CFG_PROP]: DEFAULT_FILTER_AND_CFG_FILLER,
            [UserPreferences.TABLE_CFG_PROP]: DEFAULT_TABLE_CFG_FILLER
        },
        MARKETING: {
            [UserPreferences.FILTER_CFG_PROP]: DEFAULT_FILTER_AND_CFG_MARKETING,
            [UserPreferences.TABLE_CFG_PROP]: DEFAULT_TABLE_CFG_MARKETING
        },
        CLIENT: {
            [UserPreferences.FILTER_CFG_PROP]: DEFAULT_FILTER_AND_CFG_CLIENT,
            [UserPreferences.TABLE_CFG_PROP]: DEFAULT_TABLE_CFG_CLIENT,
        }

    }

    static userSettings = {}

    /**
     * @param {int|string|null} userId Optional 
     */
    static async setUserId(userId) {
        if (userId === null) {
            userId = "_anonymous"
        }

        UserPreferences.userId = userId
        const settings = await UserSettingsRepo.get(userId)
        if (settings[UserPreferences.CURRENT_SETTINGS_VERSION] === UserPreferences.CURRENT_SETTINGS_VERSION) {
            UserPreferences.userSettings = settings
        } else {
            const userSettings = {}
            for (const profile of Object.values(SETTINGS_PROFILE)) {
                for (const prop of Object.keys(UserPreferences.DEFAULTS[profile])) {
                    if (!userSettings[profile]) {
                        userSettings[profile] = {}
                    }
                    userSettings[profile][prop] = CloneUtils.deepClone(UserPreferences.DEFAULTS[profile][prop])
                }
            }
            userSettings[UserPreferences.CURRENT_SETTINGS_VERSION] = UserPreferences.CURRENT_SETTINGS_VERSION
            userSettings[UserPreferences.PROFILE_PROP] = SETTINGS_PROFILE.CLIENT
            UserPreferences.userSettings = userSettings
            UserPreferences._set(userSettings)
        }

    }
    /**
     * @param {int|string} configProp Required 
     */
    static get(configProp) {
        const config = UserPreferences.userSettings?.[UserPreferences.userSettings?.[UserPreferences.PROFILE_PROP]]?.[configProp]
        const preferredProfile = UserPreferences.userSettings?.[UserPreferences.PROFILE_PROP] || SETTINGS_PROFILE.CLIENT
        return config === undefined ? UserPreferences.DEFAULTS[preferredProfile][configProp] : config
    }

    static getPreferredProfile() {
        return UserPreferences.userSettings[UserPreferences.PROFILE_PROP];
    }

    /**
     * @param {int|string} configProp Required 
     * @param {{}} settings Required
     */
    static save(configProp, settings) {
        UserPreferences.userSettings[UserPreferences.userSettings[UserPreferences.PROFILE_PROP]][configProp] = settings
        UserSettingsRepo.save(UserPreferences.userId, UserPreferences.userSettings)
    }

    static resetProfile() {
        const profile = UserPreferences.userSettings[UserPreferences.PROFILE_PROP]
        for (const prop of Object.keys(UserPreferences.DEFAULTS[profile])) {
            UserPreferences.userSettings[profile][prop] = CloneUtils.deepClone(UserPreferences.DEFAULTS[profile][prop])
        }
        UserPreferences._set(UserPreferences.userSettings)
    }
    
    static updateProfile(profile) {
        UserPreferences.userSettings[UserPreferences.PROFILE_PROP] = profile;
        UserPreferences._set(UserPreferences.userSettings)
    }

    static _set(settings) {
        UserSettingsRepo.save(UserPreferences.userId, settings)
    }

}

UserPreferences.setUserId(AuthService.getUserId()).catch(() => {
    Alert.error("Failed to load user settings. Please refresh your page.")
})

AuthMonitor.registerAuthChangeListener(() => {
    UserPreferences.setUserId(AuthService.getUserId()).catch(() => {
        Alert.error("Failed to load user settings. Please refresh your page.")
    })
})

export default UserPreferences